import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { HeaderComponent } from './components/header/header.component';
import { NotificationComponent } from './components/notification/notification.component'
import { MatSidenavModule } from '@angular/material/sidenav';
import { MaterialModule } from './material.module'
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './components/login/login.component';
import { LandingPageComponent } from './components/landingPage/landing-page.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MentorshipDetailsComponent } from './components/mentorship-details/mentorship-details.component'
import { MeetingDetailsPopupComponent } from './components/meeting-details-popup/meeting-details-popup.component'
import { NavigationComponent } from './components/navigation/navigation.component'
import { AdminAuthInterceptor } from '../admin/services/admin-interceptor.service';
import { MentorAuthInterceptor } from '../mentor/services/mentor-interceptor.service';
import { ScholarAuthInterceptor } from '../scholar/services/scholar-interceptor.service';
import { TrimValidator } from '../shared/directives/trim-validator-directive'
import { ViewFeedbackComponent } from './components/view-feedback/view-feedback.component';
import { LeadingZeroPipe } from './remove-leading-zero/leading-zero.pipe';
import { MeetingNotesWindowComponent } from './components/meeting-notes-window/meeting-notes-window.component'
import { MatBadgeModule } from '@angular/material';
import { MatPaginatorModule } from '@angular/material';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { FooterComponent } from './components/footer/footer.component';
@NgModule({
    declarations: [
        SideNavComponent,
        HeaderComponent,
        NotificationComponent,
        LandingPageComponent,
        LoginComponent,
        MentorshipDetailsComponent,
        MeetingDetailsPopupComponent,
        NavigationComponent,
        TrimValidator,
        ViewFeedbackComponent,
        LeadingZeroPipe,
        MeetingNotesWindowComponent,
        ResetPasswordComponent,
        UpdatePasswordComponent,
        FooterComponent
    ],
    imports: [
        FormsModule,
        RouterModule,
        MatSidenavModule,
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatBadgeModule,
        MatPaginatorModule
    ],
    exports: [
        SideNavComponent,
        HeaderComponent,
        MatSidenavModule,
        FormsModule,
        RouterModule,
        MaterialModule,
        ReactiveFormsModule,
        CommonModule,
        NotificationComponent,
        HttpClientModule,
        LandingPageComponent,
        LoginComponent,
        MentorshipDetailsComponent, MeetingDetailsPopupComponent,
        NavigationComponent, TrimValidator, LeadingZeroPipe,
        MeetingNotesWindowComponent,
        FooterComponent,
        MatPaginatorModule
    ],
    entryComponents: [MeetingDetailsPopupComponent],
    providers: [{ provide: HTTP_INTERCEPTORS, useClass: AdminAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MentorAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ScholarAuthInterceptor, multi: true }]
})
export class SharedModule { }
